import { render } from "./goodsLogItem.vue?vue&type=template&id=1a0d6f76&scoped=true"
import script from "./goodsLogItem.vue?vue&type=script&lang=js"
export * from "./goodsLogItem.vue?vue&type=script&lang=js"

import "./goodsLogItem.vue?vue&type=style&index=0&id=1a0d6f76&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0d6f76"]])

export default __exports__